function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ToolDownload_Hover",
  transform: "translate(-.342)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_24",
  className: "background",
  "data-name": "Ellipse 24",
  cx: 20,
  cy: 20,
  r: 20,
  transform: "translate(.342)",
  fill: "#98c3d9"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_979",
  className: "arrow",
  "data-name": "Group 979",
  transform: "translate(1.423 .883)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_154",
  "data-name": "Path 154",
  d: "M1359.008 449.263l3.621-3.621h-3.621v-7.85h-4.851v7.85h-3.621l3.621 3.621v.018h.017l2.408 2.408 2.408-2.408h.017z",
  transform: "translate(-1337.617 -427.675)",
  fill: "#002d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_121",
  "data-name": "Line 121",
  fill: "none",
  stroke: "#082d56",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 1,
  d: "M15.11 27.853h7.71"
})));

function SvgDownloadRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadRound);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZyBpZD0iVG9vbERvd25sb2FkX0hvdmVyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4zNDIpIj4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMjQiIGNsYXNzPSJiYWNrZ3JvdW5kIiBkYXRhLW5hbWU9IkVsbGlwc2UgMjQiIGN4PSIyMCIgY3k9IjIwIiByPSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4zNDIpIiBmaWxsPSIjOThjM2Q5Ii8+CiAgICA8ZyBpZD0iR3JvdXBfOTc5IiBjbGFzcz0iYXJyb3ciIGRhdGEtbmFtZT0iR3JvdXAgOTc5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjQyMyAwLjg4MykiPgogICAgICA8cGF0aCBpZD0iUGF0aF8xNTQiIGRhdGEtbmFtZT0iUGF0aCAxNTQiIGQ9Ik0xMzU5LjAwOCw0NDkuMjYzbDMuNjIxLTMuNjIxaC0zLjYyMXYtNy44NWgtNC44NTF2Ny44NWgtMy42MjFsMy42MjEsMy42MjF2LjAxOGguMDE3bDIuNDA4LDIuNDA4LDIuNDA4LTIuNDA4aC4wMTdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzNy42MTcgLTQyNy42NzUpIiBmaWxsPSIjMDAyZDU2Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzEyMSIgZGF0YS1uYW1lPSJMaW5lIDEyMSIgeDI9IjcuNzEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1LjExIDI3Ljg1MykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzA4MmQ1NiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };